import React from "react";
import {
  f7,
  Page,
  Navbar,
  NavLeft,
  NavTitle,
  NavRight,
  Link,
  Block,
  BlockTitle,
  List,
  ListItem,
  Row,
  Col,
  Button,
  ListInput,
  Icon,
  Card,
  CardHeader,
  CardContent,
  CardFooter,
  Preloader,
  Toolbar,
  Badge,
  Swiper,
  SwiperSlide,
  Popup,
  Popover,
} from "framework7-react";
import { getDistance, convertDistance } from "geolib";

import {
  PrimaryLogo,
  ChefSvg,
  NoPopMealSvg,
  NoPopRestoSvg,
} from "../components/crumbs";

// Redux
import { connect } from "react-redux";
import { compose } from "redux";
import { firestoreConnect } from "../HOCs";
import { Collections } from "../utils/_classes";

import { CART } from "../store/actions/cart";

import {
  getCurrentTime,
  isMerchantOpen,
  totalProductPrice,
} from "../utils/_helpers";

import { getPopularMeals } from "../store/actions/popularMeals";
import { getPopularRestaurants } from "../store/actions/popularRestaurants";
import moment from "moment";

class Discover extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      search: "",
      currentDateTime: null,
      dateTimeInterval: null,
      popularMeals: {
        startDate: moment().subtract(6, "days").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
        type: "range",
      },
      popularRestaurants: {
        startDate: moment().subtract(6, "days").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
        type: "range",
      },
      restaurantsDuration: "",
      mealsDuration: "",
      popularPopup: "",
    };
  }
  render() {
    return (
      <Page
        name="discover"
        id="discover-page"
        onPageBeforeIn={this.onPageBeforeIn.bind(this)}
        onPageAfterIn={this.onPageAfterIn.bind(this)}
        style={{ backgroundColor: "#fbfbfb" }}
      >
        {/* Top Navbar */}
        <Navbar>
          <NavLeft>
            <Link id="discover-menu-button" iconF7="bars" panelOpen="left" />
          </NavLeft>
          <NavTitle sliding>
            <PrimaryLogo size="132" />
          </NavTitle>
          <NavRight>
            <Link iconOnly href="/cart/" className="glow-tag glow-4x">
              <Icon f7="cart" size="20px">
                <Badge color="red">
                  {this.props.cart === null
                    ? "0"
                    : this.props.cart
                        .map((cartObject) =>
                          cartObject.packages
                            .map((product) => product.count)
                            .reduce((a, b) => Number(a) + Number(b), 0)
                        )
                        .reduce((a, b) => Number(a) + Number(b), 0)}
                </Badge>
                <input
                  type="hidden"
                  value={
                    this.props.cart === null
                      ? "0"
                      : this.props.cart
                          .map((cartObject) =>
                            cartObject.packages
                              .map((product) => product.count)
                              .reduce((a, b) => Number(a) + Number(b), 0)
                          )
                          .reduce((a, b) => Number(a) + Number(b), 0)
                  }
                  onChange={this.$f7.methods.glow()}
                />
              </Icon>
            </Link>
          </NavRight>
        </Navbar>

        {/* Page content */}
        <div style={{ margin: 0, padding: "36px 0 0 0" }}>
          <div id="discover-title" className="discover-pattern">
            <BlockTitle
              id="search-block-large"
              strong
              style={
                parseInt(window.innerWidth) <= 800
                  ? {
                      marginTop: "0px",
                      marginBottom: "0px",
                      fontSize: "2.5em",
                      fontFamily: "Poppins",
                      textShadow: "0px 0px 1px black",
                    }
                  : {
                      marginTop: "0px",
                      marginBottom: "0px",
                      fontSize: "4.5em",
                      fontFamily: "Poppins",
                      textShadow: "0px 0px 1px black",
                    }
              }
            >
              Find Restaurants
            </BlockTitle>
            {/* Search field */}
            <div className="inputField" style={{ marginBottom: "30pt" }}>
              <div className="paddingWrapper">
                <List
                  className="inputList"
                  style={{ margin: 0, width: "calc(100% - 45px)" }}
                >
                  <ListInput
                    type="text"
                    value={this.state.search}
                    onChange={(e) => {
                      this.setState({
                        ...this.state,
                        search: e.target.value,
                      });
                      window.history.pushState({}, document.title, "/");
                    }}
                    placeholder="Search for food or merchant..."
                  >
                    <Link
                      slot="media"
                      iconF7="search"
                      style={{ height: "28px", width: "28px" }}
                    />
                    <Link
                      slot="media"
                      iconF7="pin"
                      onClick={() => {
                        if (
                          f7.$("#discover-title").hasClass("discover-title")
                        ) {
                          f7.$("#discover-title").removeClass("discover-title");
                        } else {
                          f7.$("#discover-title").addClass("discover-title");
                        }
                      }}
                      style={{
                        height: "28px",
                        width: "28px",
                        position: "absolute",
                        right: "10px",
                      }}
                    />
                  </ListInput>
                </List>

                <div className="searchFilterBtn" style={{ marginTop: "-35px" }}>
                  <Link iconF7="slider_horizontal_3" panelOpen="right"></Link>
                </div>
              </div>
            </div>
          </div>

          {/* Content */}
          <div>
            {/* {this.props.ordered.loading || */}
            {!this.props.ordered.merchants || !this.props.ordered.products ? (
              <Row className="discover-cards paddingWrapper">
                {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((n) => (
                  <Col
                    width="100"
                    xsmall="50"
                    large="33"
                    xlarge={
                      parseInt(
                        document.getElementById("discover-page")?.offsetWidth
                      ) < 1400
                        ? "33"
                        : "25"
                    }
                    key={n}
                  >
                    <Link href="#">
                      <div className="flex flex-row find-card skeleton-text skeleton-effect-pulse">
                        <div className="find-card-text">
                          <div className="flex flex-col">
                            <h2 className="skeleton-text">
                              Easychaw Experience
                            </h2>
                            <small className="skeleton-text">
                              Easychaw Experience
                            </small>
                            <div className="flex flex-row mt-10">
                              <span className="distance skeleton-text">
                                <small>00000000 km</small>
                              </span>
                            </div>
                          </div>
                          <div
                            className="vendor-open"
                            style={{ backgroundColor: "#f6f6f6", padding: 10 }}
                          ></div>
                        </div>
                        <div className="find-card-image">
                          <img
                            src="./static/transparentBg.png"
                            className="lazy lazy-fade-in"
                            alt="merchant banner"
                            style={{ backgroundColor: "#f6f6f6" }}
                          />
                          <div
                            className="completion-rate"
                            style={{ backgroundColor: "#e3e3e3", padding: 20 }}
                          ></div>
                        </div>
                      </div>
                    </Link>
                  </Col>
                ))}
              </Row>
            ) : !this.props.ordered.loading &&
              (!this.props.ordered.merchants ||
                !this.props.ordered.products) ? (
              <div
                style={{
                  margin: "20vh auto 0 auto",
                  width: "220px",
                  textAlign: "center",
                }}
              >
                <ChefSvg size="220px" />
                No options found here...
              </div>
            ) : this.props.menu.mealMenu.length > 0 &&
              this.state.search.trim() === "" &&
              this.props.ordered.merchants
                .filter(
                  (m) =>
                    m.accountStatus === "Approved" &&
                    m.currentStatus !== "offline"
                )
                .filter(
                  (m) =>
                    convertDistance(
                      getDistance(
                        this.props.discover.geoLoc,
                        m.businessProfile.geoLoc
                      ),
                      "km"
                    ) <= this.props.menu.range &&
                    m.menuCategories &&
                    m.menuCategories.some((menu) =>
                      this.props.menu.mealMenu.includes(menu)
                    )
                ).length === 0 ? (
              <div
                style={{
                  margin: "20vh auto 0 auto",
                  width: "220px",
                  textAlign: "center",
                }}
              >
                <ChefSvg size="220px" />
                No <strong>{this.props.menu.mealMenu.join(" or ")}</strong> menu
                found within {this.props.menu.range}km of your location
              </div>
            ) : this.props.menu.mealMenu.length > 0 &&
              this.state.search.trim() !== "" &&
              this.props.ordered.merchants
                .filter(
                  (m) =>
                    m.accountStatus === "Approved" &&
                    m.currentStatus !== "offline"
                )
                .filter(
                  (m) =>
                    convertDistance(
                      getDistance(
                        this.props.discover.geoLoc,
                        m.businessProfile.geoLoc
                      ),
                      "km"
                    ) <= this.props.menu.range &&
                    m.menuCategories &&
                    m.menuCategories.some((menu) =>
                      this.props.menu.mealMenu.includes(menu)
                    ) &&
                    this.props.ordered.products.some(
                      (p) =>
                        p.merchantId === m.id &&
                        this.props.menu.mealMenu.includes(p.category) &&
                        p.name
                          .toLowerCase()
                          .includes(this.state.search.toLowerCase()) &&
                        (p.available ||
                          p.available === null ||
                          p.available === undefined)
                    )
                ).length === 0 ? (
              <div
                style={{
                  margin: "20vh auto 0 auto",
                  width: "220px",
                  textAlign: "center",
                }}
              >
                <ChefSvg size="220px" />
                No <strong>{this.props.menu.mealMenu.join(" or ")}</strong> menu
                with '{this.state.search}' found within {this.props.menu.range}
                km of your location
              </div>
            ) : this.props.menu.mealMenu.length === 0 &&
              this.state.search.trim() !== "" &&
              this.props.ordered.merchants
                .filter(
                  (m) =>
                    m.accountStatus === "Approved" &&
                    m.currentStatus !== "offline"
                )
                .filter((m) =>
                  this.props.ordered.products.some(
                    (p) =>
                      p.merchantId === m.id &&
                      (p.available ||
                        p.available === null ||
                        p.available === undefined) &&
                      (p.name
                        .toLowerCase()
                        .includes(this.state.search.toLowerCase()) ||
                        m.businessProfile.name
                          .toLowerCase()
                          .includes(this.state.search.toLowerCase()))
                  )
                ).length === 0 ? (
              <div
                style={{
                  margin: "20vh auto 0 auto",
                  width: "220px",
                  textAlign: "center",
                }}
              >
                <ChefSvg size="220px" />
                No options with '{this.state.search}' found
              </div>
            ) : this.props.menu.mealMenu.length === 0 &&
              this.state.search.trim() === "" &&
              this.props.ordered.merchants
                .filter(
                  (m) =>
                    m.accountStatus === "Approved" &&
                    m.currentStatus !== "offline"
                )
                .filter(
                  (m) =>
                    convertDistance(
                      getDistance(
                        this.props.discover.geoLoc,
                        m.businessProfile.geoLoc
                      ),
                      "km"
                    ) <= this.props.menu.range
                ).length === 0 ? (
              <div
                style={{
                  margin: "20vh auto 0 auto",
                  width: "220px",
                  textAlign: "center",
                }}
              >
                <ChefSvg size="220px" />
                No options found within {this.props.menu.range}km of your
                location
              </div>
            ) : (
              <Row className="discover-cards justify-start">
                {/*
                 * --------------------
                 * Meals On Promo
                 * --------------------
                 */}
                <Col width={100}>
                  <Row className="">
                    <Col width="100" medium="50" large="40" className="px-16">
                      <Link
                        href="#"
                        popupOpen=".popular-popup"
                        onClick={() => {
                          this.setState({
                            ...this.state,
                            popularPopup: "Promo",
                          });
                        }}
                      >
                        <div className="flex flex-row find-card promo-card">
                          <div className="find-card-text">
                            <h2 className="promo promo1">
                              <span className="text-bg">
                                <div className="bounce">
                                  {" "}
                                  See best deals
                                  <br />
                                  of today
                                </div>
                              </span>
                            </h2>
                            <h2 className="promo promo2">
                              <span className="text-bg">
                                <div className="bounce">
                                  See discounted <br />
                                  meals
                                </div>
                              </span>
                            </h2>
                            <h2 className="promo promo3">
                              <span className="text-bg">
                                <div className="bounce">
                                  See meals on <br />
                                  promo
                                </div>
                              </span>
                            </h2>
                          </div>
                          <div
                            className="find-card-image bounce delay-2s"
                            id="cf4a"
                            style={{ marginRight: 20 }}
                          >
                            <img src="static/1.png" alt="meal" />
                            <img src="static/2.png" alt="meal" />
                            <img src="static/3.png" alt="meal" />
                            <img src="static/4.png" alt="meal" />
                            <img src="static/5.png" alt="meal" />
                            <img src="static/6.png" alt="meal" />
                            <img src="static/7.png" alt="meal" />
                            <img src="static/8.png" alt="meal" />
                          </div>
                          <img
                            src="static/gradient.png"
                            alt="gradient"
                            style={{
                              width: "100%",
                              position: "absolute",
                              bottom: 0,
                              borderBottomLeftRadius: 20,
                              borderBottomRightRadius: 20,
                            }}
                          />
                        </div>
                      </Link>
                    </Col>
                  </Row>
                </Col>
                {/*
                 * --------------------
                 * Popular Restaurants
                 * --------------------
                 */}
                <Col width={100} large={50}>
                  <Row className="divider">
                    <Col width="100" className="px-16" style={{ marginTop: 0 }}>
                      <div className="flex flex-row justify-between items-center">
                        <h1 className="section-header">Popular Restaurants</h1>
                        <Button
                          popupOpen=".popular-popup"
                          onClick={() => {
                            this.setState({
                              ...this.state,
                              popularPopup: "Restaurants",
                            });
                          }}
                          style={{ paddingRight: 0 }}
                        >
                          see all <Icon f7="arrow_right_square" size="12" />
                        </Button>
                      </div>
                    </Col>

                    {!this.props.data.merchants ||
                      (this.props.popularRestaurants.loading && (
                        <Col width="100" style={{ marginTop: 0 }}>
                          <Swiper
                            params={{
                              speed: 2000,
                              slidesPerView: "auto",
                              spaceBetween: 16,
                              slidesOffsetBefore: 16,
                              slidesOffsetAfter: 16,
                              effect: "slide",
                              grabCursor: true,
                            }}
                          >
                            {[1, 2, 3, 4, 5, 6, 7, 8].map((n) => (
                              <SwiperSlide key={n} style={{ width: 150 }}>
                                <Link href="#" style={{ width: "100%" }}>
                                  <div className="flex flex-col popular-card skeleton-text skeleton-effect-pulse">
                                    <div className="popular-card-image">
                                      <img
                                        src="./static/transparentBg.png"
                                        style={{ backgroundColor: "#e7e7e7" }}
                                        alt=""
                                      />
                                    </div>
                                    <div className="popular-card-text">
                                      <h3 className="skeleton-text">
                                        Card item name
                                      </h3>
                                    </div>
                                  </div>
                                </Link>
                              </SwiperSlide>
                            ))}
                          </Swiper>
                        </Col>
                      ))}

                    {this.props.popularRestaurants.error && (
                      <Col
                        width="100"
                        className="px-16"
                        style={{ marginTop: 0 }}
                      >
                        <Block className="sdab">
                          <Row className="items-center">
                            <Col>
                              <strong>Opps!</strong>
                              <p>{this.props.popularRestaurants.error}</p>
                            </Col>
                            <Col>
                              <Link
                                className="sdal"
                                href="#"
                                onClick={() => this.getPopularRestaurants()}
                              >
                                Reload
                              </Link>
                            </Col>
                          </Row>
                        </Block>
                      </Col>
                    )}

                    {this.props.data.merchants &&
                      !this.props.popularRestaurants.loading &&
                      this.props.popularRestaurants.loaded &&
                      !this.props.popularRestaurants.error &&
                      !this.props.popularRestaurants.loading &&
                      this.props.popularRestaurants.data
                        .filter(
                          ({ merchantId }) =>
                            convertDistance(
                              getDistance(
                                this.props.discover.geoLoc,
                                this.props.data.merchants[merchantId]
                                  .businessProfile.geoLoc
                              ),
                              "km"
                            ) <= this.props.menu.range
                        )
                        .filter(
                          ({ merchantId }) =>
                            this.props.data.merchants[merchantId] &&
                            this.props.data.merchants[merchantId].approved &&
                            this.props.data.merchants[merchantId]
                              .accountStatus === "Approved" &&
                            this.props.data.merchants[merchantId]
                              .currentStatus === "online"
                        ).length === 0 && (
                        <Col
                          width="100"
                          className="px-16"
                          style={{ marginTop: 0 }}
                        >
                          <Link
                            href="#"
                            popupOpen=".popular-popup"
                            onClick={() => {
                              this.setState({
                                ...this.state,
                                popularPopup: "Restaurants",
                              });
                            }}
                          >
                            <div className="no-popular-card">
                              <div className="no-popular-card-text">
                                <h2>
                                  No popular restaurants in the past week,
                                  filter to see more.
                                </h2>
                                <div className="filter-popular-btn">
                                  <span>Filter Duration</span>
                                </div>
                              </div>
                              <div className="no-popular-card-svg">
                                <NoPopRestoSvg />
                              </div>
                            </div>
                          </Link>
                        </Col>
                      )}
                    {/*
                     * ------------------------------
                     * slider for popular restaurnats
                     * ------------------------------
                     */}
                    {this.props.data.merchants &&
                      !this.props.popularRestaurants.loading &&
                      this.props.popularRestaurants.loaded &&
                      !this.props.popularRestaurants.error &&
                      this.props.popularRestaurants.data
                        .filter(
                          ({ merchantId }) =>
                            convertDistance(
                              getDistance(
                                this.props.discover.geoLoc,
                                this.props.data.merchants[merchantId]
                                  .businessProfile.geoLoc
                              ),
                              "km"
                            ) <= this.props.menu.range
                        )
                        .filter(
                          ({ merchantId }) =>
                            this.props.data.merchants[merchantId] &&
                            this.props.data.merchants[merchantId].approved &&
                            this.props.data.merchants[merchantId]
                              .accountStatus === "Approved" &&
                            this.props.data.merchants[merchantId]
                              .currentStatus === "online"
                        ).length > 0 && (
                        <Col width="100" style={{ marginTop: 0 }}>
                          <Swiper
                            params={{
                              speed: 2000,
                              slidesPerView: "auto",
                              spaceBetween: 16,
                              slidesOffsetBefore: 16,
                              slidesOffsetAfter: 16,
                              effect: "slide",
                              grabCursor: true,
                              autoplay: { delay: 5000 },
                            }}
                          >
                            {this.props.popularRestaurants.data
                              .filter(
                                ({ merchantId }) =>
                                  convertDistance(
                                    getDistance(
                                      this.props.discover.geoLoc,
                                      this.props.data.merchants[merchantId]
                                        .businessProfile.geoLoc
                                    ),
                                    "km"
                                  ) <= this.props.menu.range
                              )
                              .filter(
                                ({ merchantId }) =>
                                  this.props.data.merchants[merchantId] &&
                                  this.props.data.merchants[merchantId]
                                    .approved &&
                                  this.props.data.merchants[merchantId]
                                    .accountStatus === "Approved" &&
                                  this.props.data.merchants[merchantId]
                                    .currentStatus === "online"
                              )
                              .map(({ merchantId }) => (
                                <SwiperSlide
                                  key={merchantId}
                                  style={{ width: 150 }}
                                >
                                  <Link
                                    href={`/store/${merchantId}/`}
                                    style={{ width: "100%" }}
                                  >
                                    <div className="flex flex-col popular-card">
                                      <div className="popular-card-image">
                                        <img
                                          src={
                                            this.props.data.merchants[
                                              merchantId
                                            ]?.banner?.URL ||
                                            "static/poster.png"
                                          }
                                          style={{
                                            backgroundImage:
                                              "url(static/poster.png)",
                                            backgroundSize: "cover",
                                          }}
                                          alt=""
                                        />
                                      </div>
                                      <div className="popular-card-text">
                                        <h3>
                                          {
                                            this.props.data.merchants[
                                              merchantId
                                            ].businessProfile.name
                                          }
                                        </h3>
                                      </div>
                                    </div>
                                  </Link>
                                </SwiperSlide>
                              ))}
                          </Swiper>
                        </Col>
                      )}
                  </Row>
                </Col>

                {/*
                 * --------------------
                 * Popular Meals
                 * --------------------
                 */}
                <Col width={100} large={50}>
                  <Row className="">
                    <Col width="100" className="px-16" style={{ marginTop: 0 }}>
                      <div className="flex flex-row justify-between items-center">
                        <h1 className="section-header">Popular Meals</h1>
                        <Button
                          popupOpen=".popular-popup"
                          onClick={() => {
                            this.setState({
                              ...this.state,
                              popularPopup: "Meals",
                            });
                          }}
                          style={{ paddingRight: 0 }}
                        >
                          see all <Icon f7="arrow_right_square" size="12" />
                        </Button>
                      </div>
                    </Col>

                    {/* skeleton-cards */}
                    {!this.props.data.products ||
                      (this.props.popularMeals.loading && (
                        <Col width="100" style={{ marginTop: 0 }}>
                          <Swiper
                            params={{
                              speed: 2000,
                              slidesPerView: "auto",
                              spaceBetween: 16,
                              slidesOffsetBefore: 16,
                              slidesOffsetAfter: 16,
                              effect: "slide",
                              grabCursor: true,
                            }}
                          >
                            {[1, 2, 3, 4, 5, 6, 7, 8].map((n) => (
                              <SwiperSlide key={n} style={{ width: 150 }}>
                                <Link href="#" style={{ width: "100%" }}>
                                  <div className="flex flex-col popular-card skeleton-text skeleton-effect-pulse">
                                    <div className="popular-card-image">
                                      <img
                                        src="./static/transparentBg.png"
                                        style={{ backgroundColor: "#e7e7e7" }}
                                        alt=""
                                      />
                                    </div>
                                    <div className="popular-card-text">
                                      <h3 className="skeleton-text">
                                        Card item name
                                      </h3>
                                    </div>
                                  </div>
                                </Link>
                              </SwiperSlide>
                            ))}
                          </Swiper>
                        </Col>
                      ))}

                    {/* error-card */}
                    {this.props.popularMeals.error && (
                      <Col
                        width="100"
                        className="px-16"
                        style={{ marginTop: 0 }}
                      >
                        <Block className="sdab">
                          <Row className="items-center">
                            <Col>
                              <strong>Opps!</strong>
                              <p>{this.props.popularMeals.error}</p>
                            </Col>
                            <Col>
                              <Link
                                className="sdal"
                                href="#"
                                onClick={() => this.getPopularMeals()}
                              >
                                Reload
                              </Link>
                            </Col>
                          </Row>
                        </Block>
                      </Col>
                    )}

                    {/* empty state - card */}
                    {this.props.data.products &&
                      !this.props.popularMeals.loading &&
                      this.props.popularMeals.loaded &&
                      !this.props.popularMeals.error &&
                      this.props.popularMeals.data
                        .filter(
                          ({ merchantId }) =>
                            convertDistance(
                              getDistance(
                                this.props.discover.geoLoc,
                                this.props.data.merchants[merchantId]
                                  .businessProfile.geoLoc
                              ),
                              "km"
                            ) <= this.props.menu.range
                        )
                        .filter(
                          ({ productId, merchantId }) =>
                            this.props.data.products[productId] &&
                            this.props.data.products[productId].available &&
                            (this.props.data.products[productId].stocked ===
                              "" ||
                              Number(
                                this.props.data.products[productId].stocked
                              ) > 0) &&
                            this.props.data.merchants[merchantId] &&
                            this.props.data.merchants[merchantId].approved &&
                            this.props.data.merchants[merchantId]
                              .accountStatus === "Approved" &&
                            this.props.data.merchants[merchantId]
                              .currentStatus === "online"
                        ).length === 0 && (
                        <Col
                          width="100"
                          className="px-16"
                          style={{ marginTop: 0 }}
                        >
                          <Link
                            href="#"
                            popupOpen=".popular-popup"
                            onClick={() => {
                              this.setState({
                                ...this.state,
                                popularPopup: "Meals",
                              });
                            }}
                          >
                            <div className="no-popular-card">
                              <div className="no-popular-card-text">
                                <h2>
                                  No popular meals in the past week, filter to
                                  see more.
                                </h2>
                                <div className="filter-popular-btn">
                                  <span>Filter Duration</span>
                                </div>
                              </div>
                              <div className="no-popular-card-svg">
                                <NoPopMealSvg />
                              </div>
                            </div>
                          </Link>
                        </Col>
                      )}

                    {/*
                     * ------------------------
                     * slider for popular meals
                     * ------------------------
                     */}
                    {this.props.data.products &&
                      !this.props.popularMeals.loading &&
                      this.props.popularMeals.loaded &&
                      !this.props.popularMeals.error &&
                      !this.props.popularMeals.loading &&
                      this.props.popularMeals.data
                        .filter(
                          ({ merchantId }) =>
                            convertDistance(
                              getDistance(
                                this.props.discover.geoLoc,
                                this.props.data.merchants[merchantId]
                                  .businessProfile.geoLoc
                              ),
                              "km"
                            ) <= this.props.menu.range
                        )
                        .filter(
                          ({ productId, merchantId }) =>
                            this.props.data.products[productId] &&
                            this.props.data.products[productId].available &&
                            (this.props.data.products[productId].stocked ===
                              "" ||
                              Number(
                                this.props.data.products[productId].stocked
                              ) > 0) &&
                            this.props.data.merchants[merchantId] &&
                            this.props.data.merchants[merchantId].approved &&
                            this.props.data.merchants[merchantId]
                              .accountStatus === "Approved" &&
                            this.props.data.merchants[merchantId]
                              .currentStatus === "online"
                        ).length > 0 && (
                        <Col width="100" style={{ marginTop: 0 }}>
                          <Swiper
                            params={{
                              speed: 2000,
                              slidesPerView: "auto",
                              spaceBetween: 16,
                              slidesOffsetBefore: 16,
                              slidesOffsetAfter: 16,
                              effect: "slide",
                              grabCursor: true,
                              autoplay: { delay: 4000 },
                            }}
                          >
                            {this.props.popularMeals.data
                              .filter(
                                ({ merchantId }) =>
                                  convertDistance(
                                    getDistance(
                                      this.props.discover.geoLoc,
                                      this.props.data.merchants[merchantId]
                                        .businessProfile.geoLoc
                                    ),
                                    "km"
                                  ) <= this.props.menu.range
                              )
                              .filter(
                                ({ productId, merchantId }) =>
                                  this.props.data.products[productId] &&
                                  this.props.data.products[productId]
                                    .available &&
                                  (this.props.data.products[productId]
                                    .stocked === "" ||
                                    this.props.data.products[productId]
                                      .stocked > 0) &&
                                  this.props.data.merchants[merchantId] &&
                                  this.props.data.merchants[merchantId]
                                    .approved &&
                                  this.props.data.merchants[merchantId]
                                    .accountStatus === "Approved" &&
                                  this.props.data.merchants[merchantId]
                                    .currentStatus === "online"
                              )
                              .map(({ productId, name, merchantId }) => (
                                <SwiperSlide
                                  key={productId}
                                  style={{ width: 150 }}
                                >
                                  <Link
                                    href={`/store/${merchantId}/${productId}/`}
                                    style={{ width: "100%" }}
                                  >
                                    <div className="flex flex-col popular-card">
                                      <div className="popular-card-image">
                                        <img
                                          src={
                                            this.props.data.products[productId]
                                              ?.image?.URL ||
                                            "static/poster.png"
                                          }
                                          style={{
                                            backgroundImage:
                                              "url(static/poster.png)",
                                            backgroundSize: "cover",
                                          }}
                                          alt=""
                                        />
                                      </div>
                                      <div className="popular-card-text">
                                        <h3>
                                          {this.props.data.products[productId]
                                            .name || name}
                                        </h3>
                                      </div>
                                    </div>
                                  </Link>
                                </SwiperSlide>
                              ))}
                          </Swiper>
                        </Col>
                      )}
                  </Row>
                </Col>

                {/*
                 * --------------------
                 * Restaurants Near You
                 * --------------------
                 */}
                <Col width="100" className="px-16">
                  <h1 className="section-header">Restaurants Near You</h1>
                </Col>
                {this.props.ordered.merchants
                  .filter(
                    (m) =>
                      m.accountStatus === "Approved" &&
                      m.currentStatus !== "offline"
                  )
                  .filter((m) => {
                    if (
                      this.props.menu.mealMenu.length === 0 &&
                      this.state.search.trim() === ""
                    ) {
                      return (
                        convertDistance(
                          getDistance(
                            this.props.discover.geoLoc,
                            m.businessProfile.geoLoc
                          ),
                          "km"
                        ) <= this.props.menu.range
                      );
                    } else if (
                      this.props.menu.mealMenu.length !== 0 &&
                      this.state.search.trim() === ""
                    ) {
                      return (
                        convertDistance(
                          getDistance(
                            this.props.discover.geoLoc,
                            m.businessProfile.geoLoc
                          ),
                          "km"
                        ) <= this.props.menu.range &&
                        m.menuCategories &&
                        m.menuCategories.some((menu) =>
                          this.props.menu.mealMenu.includes(menu)
                        )
                      );
                    } else if (
                      this.props.menu.mealMenu.length === 0 &&
                      this.state.search.trim() !== ""
                    ) {
                      return this.props.ordered.products.some(
                        (p) =>
                          p.merchantId === m.id &&
                          (p.available ||
                            p.available === null ||
                            p.available === undefined) &&
                          (p.name
                            .toLowerCase()
                            .includes(this.state.search.toLowerCase()) ||
                            m.businessProfile.name
                              .toLowerCase()
                              .includes(this.state.search.toLowerCase()))
                      );
                    } else {
                      return (
                        convertDistance(
                          getDistance(
                            this.props.discover.geoLoc,
                            m.businessProfile.geoLoc
                          ),
                          "km"
                        ) <= this.props.menu.range &&
                        m.menuCategories &&
                        m.menuCategories.some((menu) =>
                          this.props.menu.mealMenu.includes(menu)
                        ) &&
                        this.props.ordered.products.some(
                          (p) =>
                            p.merchantId === m.id &&
                            (p.available ||
                              p.available === null ||
                              p.available === undefined) &&
                            this.props.menu.mealMenu.includes(p.category) &&
                            p.name
                              .toLowerCase()
                              .includes(this.state.search.toLowerCase())
                        )
                      );
                    }
                  })
                  .sort(
                    (a, b) =>
                      convertDistance(
                        getDistance(
                          this.props.discover.geoLoc,
                          a.businessProfile.geoLoc
                        ),
                        "km"
                      ) -
                      convertDistance(
                        getDistance(
                          this.props.discover.geoLoc,
                          b.businessProfile.geoLoc
                        ),
                        "km"
                      )
                  )
                  .map(
                    ({
                      id,
                      businessProfile: {
                        name,
                        geoLoc,
                        slogan,
                        images: {
                          logo: { URL },
                        },
                        city,
                        operationDays,
                        operationStartTime,
                        operationCloseTime,
                        operationTimes,
                      },
                      score,
                      banner,
                      ratings,
                      verified,
                    }) => (
                      <Col
                        width="100"
                        xsmall="50"
                        large="33"
                        xlarge={
                          parseInt(
                            document.getElementById("discover-page")
                              ?.offsetWidth
                          ) < 1400
                            ? "33"
                            : "25"
                        }
                        key={id}
                        className="px-16"
                      >
                        <Link href={`/store/${id}/`}>
                          <div className="flex flex-row find-card">
                            <div className="find-card-text">
                              <div className="flex flex-col">
                                <div>
                                  <h2>{name} </h2>

                                  {verified ? (
                                    <Icon
                                      style={{ fontSize: 12, padding: 6 }}
                                      f7="checkmark_seal_fill"
                                      color="blue"
                                    />
                                  ) : null}
                                </div>
                                <small>{city ? city : slogan}</small>
                                <div className="flex flex-row mt-10">
                                  <span className="rating">
                                    <Icon f7="star_fill" size="12px" />{" "}
                                    {ratings && ratings.length > 0 ? (
                                      <strong>
                                        {ratings &&
                                          (
                                            ratings
                                              .map((r) => r.rating)
                                              .reduce((a, b) => +a + +b) /
                                            ratings.length
                                          ).toFixed(2)}
                                      </strong>
                                    ) : (
                                      <strong>NR</strong>
                                    )}
                                  </span>
                                  <span className="dot">&#8226;</span>
                                  <span className="distance">
                                    <Icon f7="placemark" size="12px" />
                                    <small>
                                      {convertDistance(
                                        getDistance(
                                          this.props.discover.geoLoc,
                                          geoLoc
                                        ),
                                        "km"
                                      ).toFixed(2) + " km"}
                                    </small>
                                  </span>
                                </div>
                              </div>
                              {!isMerchantOpen(
                                this.state.currentDateTime,
                                operationDays,
                                operationTimes,
                                operationStartTime,
                                operationCloseTime
                              ) ? (
                                <div className="vendor-close">
                                  <strong>CLOSED</strong>
                                </div>
                              ) : (
                                <div className="vendor-open">
                                  <strong>OPEN</strong>
                                </div>
                              )}
                            </div>
                            <div className="find-card-image">
                              <img
                                data-src={
                                  banner ? banner.URL : "static/poster.png"
                                }
                                src="static/picloading1.gif"
                                className="lazy lazy-fade-in"
                                alt="merchant banner"
                              />
                              <div className="completion-rate">
                                <strong>
                                  {score
                                    ? Math.floor(
                                        (score?.success / score?.total) * 100
                                      ) + "%"
                                    : "0%"}
                                </strong>
                              </div>
                              {/* {verified ? (
                                <div className="verified-badge">
                                  <strong>
                                    <Icon
                                      f7="checkmark_seal_fill"
                                      color="blue"
                                    />
                                  </strong>
                                </div>
                              ) : null} */}
                            </div>
                          </div>
                        </Link>
                      </Col>
                    )
                  )}
              </Row>
            )}
          </div>
        </div>

        <Toolbar
          hidden
          position="top"
          id="searchBar"
          className="bg-color-cornsilk"
          style={{
            backgroundSize: "35%",
            height: "50px",
            zIndex: 499,
          }}
        >
          <Row noGap style={{ width: "100%" }}>
            <Col width="80">
              <input
                type="text"
                style={{
                  width: "100%",
                  height: "36px",
                  backgroundColor: "#fcfcfc",
                  borderTopLeftRadius: "20px",
                  borderBottomLeftRadius: "20px",
                  paddingLeft: "16px",
                }}
                value={this.state.search}
                onChange={(e) =>
                  this.setState({
                    ...this.state,
                    search: e.target.value,
                  })
                }
                placeholder="Search for food or merchant..."
              />
            </Col>

            <Col width="20">
              <pre
                style={{
                  height: "36px",
                  margin: "0px",
                  backgroundColor: "#fafafa",
                  textAlign: "center",
                  borderTopRightRadius: "20px",
                  borderBottomRightRadius: "20px",
                }}
              >
                <Link iconF7="slider_horizontal_3" panelOpen="right"></Link>
              </pre>
            </Col>
          </Row>
        </Toolbar>

        {/* Popup popular cards */}
        <Popup
          className="popular-popup"
          onPopupClosed={() =>
            this.setState({
              ...this.state,
              popularPopup: "",
              restaurantsDuration: "",
              mealsDuration: "",
            })
          }
        >
          <Page>
            <Navbar>
              <NavRight>
                <Link popupClose>Close</Link>
              </NavRight>
              <NavTitle sliding>
                {this.state.popularPopup === "Promo"
                  ? "Promo Meals"
                  : `Popular ${this.state.popularPopup}`}
              </NavTitle>
            </Navbar>

            <Block className="pattern-banner bg-color-theme">
              <Card style={{ width: "100%", margin: 0 }}>
                <CardHeader style={{ padding: 0 }}>
                  <List style={{ width: "100%", fontFamily: "Poppins" }}>
                    <ListItem link="#" popoverOpen=".popover-filter">
                      <Icon slot="media" f7="line_horizontal_3_decrease" />
                      <h3 slot="title">
                        {this.state.popularPopup !== "Promo"
                          ? "Filter Duration"
                          : "Promo Meals"}
                      </h3>
                      {this.state.popularPopup !== "Promo" ? (
                        <div slot="after" className="flex items-center">
                          {this.state.popularPopup === "Restaurants"
                            ? this.state.restaurantsDuration
                            : this.state.mealsDuration}
                        </div>
                      ) : null}
                    </ListItem>
                  </List>
                </CardHeader>
              </Card>
            </Block>
            <Popover className="popover-filter">
              <List>
                <ListItem
                  title="Today"
                  link="#"
                  popoverClose=".popover-filter"
                  onClick={() => this.switchDuration("Today")}
                ></ListItem>
                <ListItem
                  title="Week"
                  link="#"
                  popoverClose=".popover-filter"
                  onClick={() => this.switchDuration("Week")}
                ></ListItem>
                <ListItem
                  title="Month"
                  link="#"
                  popoverClose=".popover-filter"
                  onClick={() => this.switchDuration("Month")}
                ></ListItem>
                <ListItem
                  title="All Time"
                  link="#"
                  popoverClose=".popover-filter"
                  onClick={() => this.switchDuration("All Time")}
                ></ListItem>
              </List>
            </Popover>

            {/*
             * ---------------------------
             * Display popular restaurants
             * ---------------------------
             */}
            {this.state.popularPopup === "Restaurants" ? (
              this.props.popularRestaurants.data
                .filter(
                  ({ merchantId }) =>
                    convertDistance(
                      getDistance(
                        this.props.discover.geoLoc,
                        this.props.data.merchants[merchantId].businessProfile
                          .geoLoc
                      ),
                      "km"
                    ) <= this.props.menu.range
                )
                .filter(
                  ({ merchantId }) =>
                    this.props.data.merchants[merchantId] &&
                    this.props.data.merchants[merchantId].approved &&
                    this.props.data.merchants[merchantId].accountStatus ===
                      "Approved" &&
                    this.props.data.merchants[merchantId].currentStatus ===
                      "online"
                ).length > 0 ? (
                <Row className="discover-cards" noGap>
                  {this.props.popularRestaurants.data
                    .filter(
                      ({ merchantId }) =>
                        convertDistance(
                          getDistance(
                            this.props.discover.geoLoc,
                            this.props.data.merchants[merchantId]
                              .businessProfile.geoLoc
                          ),
                          "km"
                        ) <= this.props.menu.range
                    )
                    .filter(
                      ({ merchantId }) =>
                        this.props.data.merchants[merchantId] &&
                        this.props.data.merchants[merchantId].approved &&
                        this.props.data.merchants[merchantId].accountStatus ===
                          "Approved" &&
                        this.props.data.merchants[merchantId].currentStatus ===
                          "online"
                    )
                    .map(({ merchantId }) => (
                      <Col
                        width="100"
                        medium="50"
                        key={merchantId}
                        className="px-16"
                      >
                        <Link
                          href={`/store/${merchantId}/`}
                          popupClose=".popular-popup"
                        >
                          <div className="flex flex-row find-card">
                            <div className="find-card-text">
                              <div className="flex flex-col">
                                <div>
                                  <h2>
                                    {
                                      this.props.data.merchants[merchantId]
                                        .businessProfile.name
                                    }
                                  </h2>

                                  {this.props.data.merchants[merchantId]
                                    .verified ? (
                                    <Icon
                                      style={{ fontSize: 12, padding: 6 }}
                                      f7="checkmark_seal_fill"
                                      color="blue"
                                    />
                                  ) : null}
                                </div>
                                <small>
                                  {this.props.data.merchants[merchantId]
                                    .businessProfile?.city ||
                                    this.props.data.merchants[merchantId]
                                      .businessProfile?.slogan}
                                </small>
                                <div className="flex flex-row mt-10">
                                  <span className="rating">
                                    <Icon f7="star_fill" size="12px" />{" "}
                                    {this.props.data.merchants[merchantId]
                                      .ratings &&
                                    this.props.data.merchants[merchantId]
                                      .ratings.length > 0 ? (
                                      <strong>
                                        {this.props.data.merchants[merchantId]
                                          .ratings &&
                                          (
                                            this.props.data.merchants[
                                              merchantId
                                            ].ratings
                                              .map((r) => r.rating)
                                              .reduce((a, b) => +a + +b) /
                                            this.props.data.merchants[
                                              merchantId
                                            ].ratings.length
                                          ).toFixed(2)}
                                      </strong>
                                    ) : (
                                      <strong>NR</strong>
                                    )}
                                  </span>
                                  <span className="dot">&#8226;</span>
                                  <span className="distance">
                                    <Icon f7="placemark" size="12px" />
                                    <small>
                                      {" "}
                                      {convertDistance(
                                        getDistance(
                                          this.props.discover.geoLoc,
                                          this.props.data.merchants[merchantId]
                                            .businessProfile?.geoLoc
                                        ),
                                        "km"
                                      ).toFixed(2) + " km"}
                                    </small>
                                  </span>
                                </div>
                              </div>
                              {!isMerchantOpen(
                                this.state.currentDateTime,
                                this.props.data.merchants[merchantId]
                                  .businessProfile?.operationDays,
                                this.props.data.merchants[merchantId]
                                  .businessProfile?.operationTimes,
                                this.props.data.merchants[merchantId]
                                  .businessProfile?.operationStartTime,
                                this.props.data.merchants[merchantId]
                                  .businessProfile?.operationCloseTime
                              ) ? (
                                <div className="vendor-close">
                                  <strong>CLOSED</strong>
                                </div>
                              ) : (
                                <div className="vendor-open">
                                  <strong>OPEN</strong>
                                </div>
                              )}
                            </div>
                            <div className="find-card-image">
                              <img
                                data-src={"static/poster.png"}
                                src={
                                  this.props.data.merchants[merchantId].banner
                                    ? this.props.data.merchants[merchantId]
                                        .banner.URL
                                    : "static/picloading1.gif"
                                }
                                className="lazy lazy-fade-in"
                                alt="merchant banner"
                              />
                              <div className="completion-rate">
                                <strong>
                                  {this.props.data.merchants[merchantId].score
                                    ? Math.floor(
                                        (this.props.data.merchants[merchantId]
                                          .score?.success /
                                          this.props.data.merchants[merchantId]
                                            .score?.total) *
                                          100
                                      ) + "%"
                                    : "0%"}
                                </strong>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </Col>
                    ))}
                </Row>
              ) : (
                <div style={{ textAlign: "center", marginTop: "12%" }}>
                  <img src="static/chef.svg" style={{ width: "300px" }} />
                  <h6>No popular restaurants here at the moment.</h6>
                </div>
              )
            ) : null}

            {/*
             * ---------------------------
             * Display popular meals
             * ---------------------------
             */}
            {this.state.popularPopup === "Meals" ? (
              this.props.data.products &&
              this.props.popularMeals.loaded &&
              !this.props.popularMeals.error &&
              !this.props.popularMeals.loading &&
              this.props.popularMeals.data
                .filter(
                  ({ merchantId }) =>
                    convertDistance(
                      getDistance(
                        this.props.discover.geoLoc,
                        this.props.data.merchants[merchantId].businessProfile
                          .geoLoc
                      ),
                      "km"
                    ) <= this.props.menu.range
                )
                .filter(
                  ({ productId, merchantId }) =>
                    this.props.data.products[productId] &&
                    this.props.data.products[productId].available &&
                    (this.props.data.products[productId].stocked === "" ||
                      Number(this.props.data.products[productId].stocked) >
                        0) &&
                    this.props.data.merchants[merchantId] &&
                    this.props.data.merchants[merchantId].approved &&
                    this.props.data.merchants[merchantId].accountStatus ===
                      "Approved" &&
                    this.props.data.merchants[merchantId].currentStatus ===
                      "online"
                ).length > 0 ? (
                <Row className="discover-cards" noGap>
                  {this.props.popularMeals.data
                    .filter(
                      ({ merchantId }) =>
                        convertDistance(
                          getDistance(
                            this.props.discover.geoLoc,
                            this.props.data.merchants[merchantId]
                              .businessProfile.geoLoc
                          ),
                          "km"
                        ) <= this.props.menu.range
                    )
                    .filter(
                      ({ productId, merchantId }) =>
                        this.props.data.products[productId] &&
                        this.props.data.products[productId].available &&
                        (this.props.data.products[productId].stocked === "" ||
                          Number(this.props.data.products[productId].stocked) >
                            0) &&
                        this.props.data.merchants[merchantId] &&
                        this.props.data.merchants[merchantId].approved &&
                        this.props.data.merchants[merchantId].accountStatus ===
                          "Approved" &&
                        this.props.data.merchants[merchantId].currentStatus ===
                          "online"
                    )
                    .map(({ productId, merchantId, name }) => (
                      <Col
                        width="100"
                        medium="50"
                        key={productId}
                        className="px-16"
                      >
                        <Link
                          href={`/store/${merchantId}/${productId}/`}
                          popupClose=".popular-popup"
                        >
                          <Card
                            style={{
                              overflow: "hidden",
                              width: "100%",
                            }}
                          >
                            <Row noGap>
                              <Col width="60">
                                <List className="noFullText">
                                  <ListItem>
                                    <h4
                                      className="item-name"
                                      slot="title"
                                      style={{ marginTop: 8 }}
                                    >
                                      {name.length > 20
                                        ? name
                                            .substring(0, 25)
                                            .trim()
                                            .concat("...")
                                        : name}
                                    </h4>

                                    <p className="item-stock" slot="title">
                                      <small>{`${
                                        this.props.data.products[productId]
                                          .text === ""
                                          ? "No item description"
                                          : this.props.data.products[productId]
                                              .text
                                      }`}</small>
                                    </p>

                                    <p className="item-stock" slot="title">
                                      <small>
                                        {this.props.data.products[productId]
                                          .stocked === ""
                                          ? "Stocked"
                                          : `${this.props.data.products[productId].stocked} left`}
                                      </small>
                                    </p>

                                    {/* Only show if there's a discount */}
                                    {this.props.data.products[productId]
                                      .discount !== "" ? (
                                      <small
                                        className="item-price"
                                        slot="title"
                                      >
                                        <s style={{ color: "orange" }}>
                                          {new Intl.NumberFormat("en-GB", {
                                            style: "currency",
                                            currency: "NGN",
                                          }).format(
                                            totalProductPrice(
                                              this.props.data.products[
                                                productId
                                              ].price
                                            )
                                          )}
                                        </s>
                                        &nbsp;&nbsp;
                                      </small>
                                    ) : (
                                      <small
                                        className="item-price"
                                        slot="title"
                                      >
                                        {new Intl.NumberFormat("en-GB", {
                                          style: "currency",
                                          currency: "NGN",
                                        }).format(
                                          totalProductPrice(
                                            this.props.data.products[productId]
                                              .price
                                          )
                                        )}
                                      </small>
                                    )}
                                  </ListItem>
                                </List>
                              </Col>

                              <Col
                                width="40"
                                style={{
                                  backgroundImage:
                                    "url(static/icon-512x512@1x.png)",
                                  backgroundSize: "cover",
                                  maxHeight: "140px",
                                  position: "relative",
                                }}
                              >
                                <img
                                  className="item-image"
                                  src={
                                    this.props.data.products[productId]?.image
                                      ?.URL || "static/poster.png"
                                  }
                                  alt="item logo"
                                  style={{
                                    opacity: 0.98,
                                  }}
                                />

                                {this.props.data.products[productId]
                                  .discount !== "" && (
                                  <div className="discounted-price">
                                    {new Intl.NumberFormat("en-GB", {
                                      style: "currency",
                                      currency: "NGN",
                                    }).format(
                                      totalProductPrice(
                                        this.props.data.products[productId]
                                          .price,
                                        this.props.data.products[productId]
                                          .discount
                                      )
                                    )}
                                  </div>
                                )}
                              </Col>
                            </Row>
                          </Card>
                        </Link>
                      </Col>
                    ))}
                </Row>
              ) : (
                <div style={{ textAlign: "center", marginTop: "12%" }}>
                  <img src="static/chef.svg" style={{ width: "300px" }} />
                  <h6>No popular meals here at the moment.</h6>
                </div>
              )
            ) : null}

            {/*
             * ---------------------------
             * Display meals on promo
             * ---------------------------
             */}
            {this.state.popularPopup === "Promo" ? (
              this.props.ordered.products &&
              this.props.ordered.merchants &&
              this.props.data.products &&
              this.props.data.merchants ? (
                <Row className="discover-cards" noGap>
                  {this.props.ordered.products
                    .filter(
                      (product) =>
                        product?.discount &&
                        product?.available &&
                        (product?.stocked === "" ||
                          Number(product?.stocked) > 0)
                    )
                    .filter(
                      ({ merchantId }) =>
                        convertDistance(
                          getDistance(
                            this.props.discover.geoLoc,
                            this.props.data.merchants[merchantId]
                              .businessProfile.geoLoc
                          ),
                          "km"
                        ) <= this.props.menu.range &&
                        this.props.data.merchants[merchantId] &&
                        this.props.data.merchants[merchantId].approved &&
                        this.props.data.merchants[merchantId].accountStatus ===
                          "Approved" &&
                        this.props.data.merchants[merchantId].currentStatus ===
                          "online"
                    )
                    .sort((a, b) => Number(b.discount) - Number(a.discount), [])
                    .map(
                      ({
                        id,
                        merchantId,
                        name,
                        discount,
                        text,
                        stocked,
                        price,
                        image: { URL },
                      }) => (
                        <Col width="100" medium="50" key={id} className="px-16">
                          <Link href={`/store/${merchantId}/${id}/`}>
                            <Card
                              style={{
                                overflow: "hidden",
                                width: "100%",
                              }}
                            >
                              <Row noGap>
                                <Col width="60">
                                  <List className="noFullText">
                                    <ListItem>
                                      <h4
                                        className="item-name"
                                        slot="title"
                                        style={{ marginTop: 8 }}
                                      >
                                        {name.length > 20
                                          ? name
                                              .substring(0, 25)
                                              .trim()
                                              .concat("...")
                                          : name}
                                      </h4>
                                      <p className="item-stock" slot="title">
                                        <small>{`${
                                          text === ""
                                            ? "No item description"
                                            : text
                                        }`}</small>
                                      </p>

                                      {/* Only show if there's a stock quantity or out of stock*/}
                                      <p className="item-stock" slot="title">
                                        <small>{`${
                                          stocked === ""
                                            ? "Stocked"
                                            : stocked + " left"
                                        }`}</small>
                                      </p>

                                      {/* Only show if there's a discount */}
                                      {true ? (
                                        <small
                                          className="item-price"
                                          slot="title"
                                        >
                                          <s style={{ color: "orange" }}>
                                            {new Intl.NumberFormat("en-GB", {
                                              style: "currency",
                                              currency: "NGN",
                                            }).format(totalProductPrice(price))}
                                          </s>
                                          &nbsp;&nbsp;
                                        </small>
                                      ) : null}
                                    </ListItem>
                                  </List>
                                </Col>

                                <Col
                                  width="40"
                                  style={{
                                    backgroundImage:
                                      "url(static/icon-512x512@1x.png)",
                                    backgroundSize: "cover",
                                    maxHeight: "140px",
                                    position: "relative",
                                  }}
                                >
                                  <img
                                    className="item-image"
                                    src={URL || "static/poster.png"}
                                    alt="item logo"
                                    style={{
                                      opacity: 0.98,
                                    }}
                                  />

                                  <div className="discounted-price">
                                    {new Intl.NumberFormat("en-GB", {
                                      style: "currency",
                                      currency: "NGN",
                                    }).format(
                                      totalProductPrice(price, discount)
                                    )}
                                  </div>
                                  <div className="discounted-percentage">
                                    <strong>{discount}% off</strong>
                                  </div>
                                </Col>
                              </Row>
                            </Card>
                          </Link>
                        </Col>
                      )
                    )}
                </Row>
              ) : (
                <div style={{ textAlign: "center", marginTop: "12%" }}>
                  <img src="static/chef.svg" style={{ width: "300px" }} />
                  <h6>No meals on promo here at the moment.</h6>
                </div>
              )
            ) : null}
          </Page>
        </Popup>
      </Page>
    );
  }

  // methods
  switchDuration(duration) {
    // const duration = e.target.value;
    const search =
      this.state.popularPopup === "Restaurants"
        ? "popularRestaurants"
        : "popularMeals";
    const durationType =
      this.state.popularPopup === "Restaurants"
        ? "restaurantsDuration"
        : "mealsDuration";
    switch (duration) {
      case "Today":
        this.setState(
          {
            ...this.state,
            [durationType]: duration,
            [search]: {
              ...this.state[search],
              startDate: moment().format("YYYY-MM-DD"),
              endDate: moment().format("YYYY-MM-DD"),
              type: "range",
            },
          },
          () => {
            if (this.state.popularPopup === "Restaurants") {
              this.getPopularRestaurants();
            } else {
              this.getPopularMeals();
            }
          }
        );
        break;
      case "Week":
        this.setState(
          {
            ...this.state,
            [durationType]: duration,
            [search]: {
              ...this.state[search],
              startDate: moment().subtract(7, "days").format("YYYY-MM-DD"),
              endDate: moment().format("YYYY-MM-DD"),
              type: "range",
            },
          },
          () => {
            if (this.state.popularPopup === "Restaurants") {
              this.getPopularRestaurants();
            } else {
              this.getPopularMeals();
            }
          }
        );
        break;
      case "Month":
        this.setState(
          {
            ...this.state,
            [durationType]: duration,
            [search]: {
              ...this.state[search],
              startDate: moment().subtract(30, "days").format("YYYY-MM-DD"),
              endDate: moment().format("YYYY-MM-DD"),
              type: "range",
            },
          },
          () => {
            if (this.state.popularPopup === "Restaurants") {
              this.getPopularRestaurants();
            } else {
              this.getPopularMeals();
            }
          }
        );
        break;
      default:
        this.setState(
          {
            ...this.state,
            [durationType]: duration,
            [search]: {
              ...this.state[search],
              type: "all",
            },
          },
          () => {
            if (this.state.popularPopup === "Restaurants") {
              this.getPopularRestaurants();
            } else {
              this.getPopularMeals();
            }
          }
        );
        break;
    }
  }

  //events
  onPageBeforeIn() {
    localStorage.intro ? null : (localStorage.intro = true);

    //show/hide tool bar if the large search block is visible
    f7.toolbar.hide("#searchBar");
    f7.$(".page-content").on("scroll", () => {
      if (f7.$("#search-block-large").offset()) {
        let searchBlockTop = f7.$("#search-block-large").offset().top;
        if (searchBlockTop <= -200) {
          f7.toolbar.show("#searchBar");
        } else if (searchBlockTop >= 20) {
          f7.toolbar.hide("#searchBar");
        }
      }
    });

    // check if url has merchant search
    let searchMerchant = window.location.search.split("=");
    if (searchMerchant.length > 1) {
      const decodedSearchMerchant = decodeURIComponent(searchMerchant[1]);
      this.setState({
        ...this.state,
        search: decodedSearchMerchant,
      });
    }
  }

  onPageAfterIn() {
    //show/hide tool bar if the large search block is visible
    f7.toolbar.hide("#searchBar");

    // lazy load images
    var pageAfter = setInterval(() => {
      if (f7.$("img.lazy").length != 0) {
        f7.lazy.create("#discover-page");
        f7.$("img.lazy").trigger("lazy");
        f7.$("div.lazy").trigger("lazy");
        clearInterval(pageAfter);
      }
    }, 1000);

    // replay animation
    setInterval((_) => {
      f7.$(".no-popular-card-svg svg").addClass("active");
    }, 1000);
  }

  getPopularRestaurants() {
    this.props.getPopularRestaurants(
      this.state.popularRestaurants.startDate,
      this.state.popularRestaurants.endDate,
      this.state.popularRestaurants.type
    );
  }

  getPopularMeals() {
    this.props.getPopularMeals(
      this.state.popularMeals.startDate,
      this.state.popularMeals.endDate,
      this.state.popularMeals.type
    );
  }

  //   Lifecycle
  componentDidUpdate(prevProps, prevState) {
    let storageCart = JSON.parse(localStorage.getItem("cart"));

    // if there is a cart in localstorage
    if (
      storageCart !== null &&
      !this.props.data.loading &&
      (!prevProps.data.products || !prevProps.data.merchants) &&
      this.props.data.merchants &&
      this.props.data.products
    ) {
      // check to see if product in cart has not been deleted && merchant has not been suspended
      storageCart = storageCart.filter((cart) => {
        if (
          this.props.data.merchants &&
          this.props.data.merchants[cart.merchantId] &&
          this.props.data.merchants[cart.merchantId].accountStatus ===
            "Approved"
        ) {
          cart.packages = cart.packages.filter((p) => {
            if (
              this.props.data.products &&
              this.props.data.products[p.productId]
            ) {
              return p;
            }
          });

          if (cart.packages.length > 0) {
            return cart;
          }
        }
      });

      if (storageCart.length === 0) {
        localStorage.removeItem("cart");
        this.props.dispatch({ type: CART, payload: null });
      } else {
        // dispatch to redux store for display on discove and store page
        this.props.dispatch({ type: CART, payload: storageCart });
      }
    }
  }

  componentDidMount() {
    let storageCart = JSON.parse(localStorage.getItem("cart"));

    // if there is a cart in localstorage
    if (
      storageCart !== null &&
      this.props.data.merchants &&
      this.props.data.products
    ) {
      // check to see if product in cart has not been deleted && merchant has not been suspended
      storageCart = storageCart.filter((cart) => {
        if (
          this.props.data.merchants &&
          this.props.data.merchants[cart.merchantId] &&
          this.props.data.merchants[cart.merchantId].accountStatus ===
            "Approved"
        ) {
          cart.packages = cart.packages.filter((p) => {
            if (
              this.props.data.products &&
              this.props.data.products[p.productId]
            ) {
              return p;
            }
          });

          if (cart.packages.length > 0) {
            return cart;
          }
        }
      });

      if (storageCart.length === 0) {
        localStorage.removeItem("cart");
        this.props.dispatch({ type: CART, payload: null });
      } else {
        // dispatch to redux store for display on discove and store page
        this.props.dispatch({ type: CART, payload: storageCart });
      }
    }

    const dateTimeInterval = setInterval(() => {
      getCurrentTime((error, currentDateTime) => {
        if (error) {
          return console.log(error);
        }

        this.setState({
          ...this.state,
          currentDateTime,
        });
      });
    }, 30000);

    // load popular meals
    if (!this.props.popularMeals.loaded) {
      this.getPopularMeals();
    }
    // loadPopularRestaurants
    if (!this.props.popularRestaurants.loaded) {
      this.getPopularRestaurants();
    }

    this.setState({
      ...this.state,
      dateTimeInterval,
    });
  }

  componentWillUnmount() {
    if (this.state.dateTimeInterval) {
      clearInterval(this.state.dateTimeInterval);
      this.setState({
        ...this.state,
        dateTimeInterval: null,
      });
    }
  }
}

const mapStateToProps = ({
  DB: { ordered, data },
  cart,
  discover,
  menu,
  popularMeals,
  popularRestaurants,
}) => ({
  ordered,
  data,
  cart,
  discover,
  menu,
  popularMeals,
  popularRestaurants,
});

const mapDispatchToProps = (dispatch) => ({
  getPopularMeals: (startDate, endDate, type) =>
    dispatch(getPopularMeals(startDate, endDate, type)),
  getPopularRestaurants: (startDate, endDate, type) =>
    dispatch(getPopularRestaurants(startDate, endDate, type)),
});

const enhance = compose(
  firestoreConnect([new Collections("merchants"), new Collections("products")]),
  connect(mapStateToProps, mapDispatchToProps)
);

export default enhance(Discover);
